import script from "./VerifyEmail.vue?vue&type=script&setup=true&lang=js"
export * from "./VerifyEmail.vue?vue&type=script&setup=true&lang=js"

import "./VerifyEmail.vue?vue&type=style&index=0&id=93f1c880&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026_previous\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93f1c880"]])

export default __exports__